module.exports = __webpack_public_path__ + "static/media/judge-prof-dai-bing-tian.c952b25c.jpg";